import * as React from "react";

function SvgKnowledge({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M19.652 14.349a3.746 3.746 0 01.477 4.718l1.401 1.403a.749.749 0 01-.976 1.133l-.084-.073-1.402-1.401-.118.078a3.767 3.767 0 01-4.085-.12 3.752 3.752 0 114.787-5.738zM17 2.25a2.75 2.75 0 012.745 2.582L19.75 5v6a.75.75 0 01-1.493.102L18.25 11V5a1.25 1.25 0 00-1.122-1.244L17 3.75H7.75v11.5H11a.75.75 0 01.102 1.493L11 16.75H5a1.25 1.25 0 00-.128 2.494L5 19.25h6a.75.75 0 01.102 1.493L11 20.75H5c-1.52 0-2.75-1.23-2.75-2.75V5a2.75 2.75 0 012.582-2.745L5 2.25h12zm-1.592 13.16a2.253 2.253 0 00.319 3.45c.744.522 1.8.522 2.545 0a2.256 2.256 0 00.432-3.33l-.113-.12-.13-.12a2.248 2.248 0 00-3.053.12zM6.25 3.75H5a1.25 1.25 0 00-1.244 1.122L3.75 5v10.55a2.722 2.722 0 011.082-.295L5 15.25h1.25V3.75z"
        />
      </g>
    </svg>
  );
}

export default SvgKnowledge;
